import RecommendationCard from './recommendation-card';

export default RecommendationCard;
